import React, { Fragment, lazy, Suspense, useContext } from 'react';

import { Redirect, Route, Switch } from 'react-router-dom';
import ConnectingLoader from 'src/assets/images/common/connecting.svg';
import Styles from 'src/components/themeStyle';

import AuthGuard from './components/Auth/AuthGuard';
import GuestGuard from './components/Auth/GuestGuard';
import DspGuard from './components/Auth/DspGuard';
import { BASE_URL } from './config/constant';
import AdminLayout from './layouts/AdminLayout';
import AuthLayout from './layouts/AuthLayout';
import { ThemeContext } from './providers/themeProvider';
import { useRedirectJourney } from './hooks/useRedirectJourney';
import SessionLogs from './views/pages/session-logs';
import CampaignGenrationLayout from './layouts/CampaignGenarionLayout';
import AmcAccessGuard from './components/Auth/AmcAccessGuard';
import DspAccessGuard from './components/Auth/DspAccessGuard';
import SpAdsAccessGuard from './components/Auth/SpAdsAccessGuard';
import DspPlatformFeeAccessGuard from './components/Auth/DspPlatformFeeAccessGuard';
import SubscriptionGuard from './components/Auth/SubscriptionGuard';

const StyleTag = () => {
  const [themeMode, setTheme] = useContext(ThemeContext);
  return (
    <div>
      <style>{Styles(themeMode.theme)}</style>
    </div>
  );
};

export const DoLoader = () => {
  return (
    <section className="h-screen d-flex align-items-center justify-content-center f-18 f-w-500 text-dark bg-white">
      <img src={ConnectingLoader} alt="Connect" className="wid-40" />
      <StyleTag />
    </section>
  );
};

const User = JSON.parse(localStorage.getItem('User'));

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<DoLoader />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;
        const AccessGuard = route.accessGuard || Fragment;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <AccessGuard>
              <Guard>
                <Layout>{route.routes ? renderRoutes(route.routes) : <Component {...props} />}</Layout>
              </Guard>
              </AccessGuard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
);

const routes = [
  {
    exact: true,
    guard: GuestGuard,
    path: '/auth/signin',
    component: lazy(() => import('./views/auth/signin/SignIn'))
  },
  // {
  //   exact: true,
  //   guard: GuestGuard,
  //   path: '/auth/signup',
  //   component: lazy(() => import('./views/auth/register/index'))
  // },
  {
    exact: true,
    guard: GuestGuard,
    path: '/auth/register',
    component: lazy(() => import('./views/auth/register/index'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/auth/book-demo',
    component: lazy(() => import('./views/auth/book-demo/index'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/auth/forgot-password',
    component: lazy(() => import('./views/auth/forgot-password/ForgotPassword'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/auth/change-password',
    component: lazy(() => import('./views/auth/change-password/ChangePassword'))
  },
  // {
  //   exact: true,
  //   layout: AuthLayout,
  //   guard: GuestGuard,
  //   path: '/',
  //   component: lazy(() => import('./views/landing')),
  // },
  // {
  //   exact: true,
  //   // layout: AuthLayout,
  //   guard: GuestGuard,
  //   path: '/landing',
  //   component: lazy(() => import('./views/landing-v2'))
  // },
  {
    exact: true,
    guard: GuestGuard,
    path: '/',
    // component: lazy(() => import('./views/landing-v3'))
    component: lazy(() => import('./views/auth/signin/SignIn'))
  },
  // {
  //   exact: true,
  //   path: '/blogs',
  //   component: lazy(() => import('./views/landing-v3/blogs'))
  // },
  // {
  //   exact: true,
  //   path: '/blogs/:blog_title',
  //   component: lazy(() => import('./views/landing-v3/blogs/details'))
  // },
  {
    exact: true,
    // layout: AuthLayout,
    guard: GuestGuard,
    path: '/contact',
    component: lazy(() => import('./views/contact'))
  },
  // {
  //   exact: true,
  //   path: '/auth/signup',
  //   component: lazy(() => import('./views/auth/signup/SignUp'))
  // },
  {
    exact: true,
    path: '/auth/otp',
    component: lazy(() => import('./views/auth/OtpVerification'))
  },
  {
    exact: true,
    guard: AuthGuard,
    path: '/getting-started',
    component: lazy(() => import('./views/pages/getting-started/index'))
  },
  {
    exact: true,
    guard: AuthGuard,
    path: '/plan-selection',
    component: lazy(() => import('./views/pages/plan-selection/index'))
  },
  {
    exact: true,
    guard: AuthGuard,
    path: '/subscription/plans/:offeringType/:paymentProvider',
    component: lazy(() => import('./views/pages/subscription-plans/index'))
  },
  {
    exact: true,
    guard: AuthGuard,
    path: '/subscription/payments',
    component: lazy(() => import('./views/pages/subscription-payments/index'))
  },
  {
    exact: true,
    guard: AuthGuard,
    path: '/salesbricks/payments/checkout',
    component: lazy(() => import('./views/pages/subscription-payments/SalesBricksCheckout'))
  },
  {
    exact: true,
    guard: AuthGuard,
    path: '/onboarding',
    component: lazy(() => import('./views/pages/subscription-payments/AmazonOnboarding'))
  },
  {
    exact: true,
    guard: AuthGuard,
    path: '/book-demo/:calendlyId?',
    component: lazy(() => import('./views/pages/calendly-demo/index'))
  },
  {
    exact: true,
    layout: AuthLayout,
    path: '/auth/terms',
    component: lazy(() => import('./views/auth/Terms'))
  },
  {
    exact: true,
    layout: AuthLayout,
    path: '/auth/support',
    component: lazy(() => import('./views/auth/Support'))
  },
  {
    exact: true,
    path: '/logout',
    component: lazy(() => import('./views/logout/index'))
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('./views/errors/NotFound404'))
  },
  {
    exact: true,
    path: '/maintenance/coming-soon',
    component: lazy(() => import('./views/maintenance/ComingSoon'))
  },
  {
    exact: true,
    path: '/maintenance/error',
    component: lazy(() => import('./views/maintenance/Error'))
  },
  {
    exact: true,
    path: '/maintenance/offline-ui',
    component: lazy(() => import('./views/maintenance/OfflineUI'))
  },
  {
    exact: true,
    layout: AdminLayout,
    guard: AuthGuard,
    path: '/amazon/restricted',
    component: lazy(() => import('./views/no-access/index'))
  },
  {
    exact: true,
    layout: AdminLayout,
    guard: AuthGuard,
    path: '/amazon-dsp/restricted',
    component: lazy(() => import('./views/no-access/DspPlatformFeeNoAccess'))
  },
  {
    exact: true,
    guard: AuthGuard,
    path: '/account-settings-new',
    component: lazy(() => import('./views/pages/accountSettings/index'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/admin/auth/aws/:country_code',
    component: lazy(() => import('./views/pages/auth/aws'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/aws/admin/callback',
    component: lazy(() => import('./views/pages/auth/aws-callback'))
  },
  {
    exact: true,
    path: '/flipkart/callback',
    component: lazy(() => import('./views/pages/auth/flipkart-callback'))
  },
  {
    exact: true,
    path: '/auth/flipkart',
    component: lazy(() => import('./views/pages/auth/flipkart-redirecting'))
  },
  {
    exact: true,
    path: '/auth/flipkart/:connectionStatus',
    component: lazy(() => import('./views/pages/thankyou/index'))
  },
  {
    exact: true,
    path: '/auth/flipkart/success',
    component: lazy(() => import('./views/pages/thankyou/index'))
  },
  {
    exact: true,
    path: '/auth/flipkart/failed',
    component: lazy(() => import('./views/pages/thankyou/index'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/admin/auth/success',
    component: lazy(() => import('./views/pages/auth/success'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/admin/auth/failed',
    component: lazy(() => import('./views/pages/auth/failed'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/admin/re-auth/success',
    component: lazy(() => import('./views/pages/auth/re-auth-success'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/admin/re-auth/failed',
    component: lazy(() => import('./views/pages/auth/re-auth-failed'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/customer-support',
    component: lazy(() => import('./views/landing-v3/customer-support/index'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/pricing-refund-cancellation',
    component: lazy(() => import('./views/landing-v3/pricing-refund-cancellation/index'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/terms-of-use',
    component: lazy(() => import('./views/landing-v3/terms-of-use/index'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/privacy-policy',
    component: lazy(() => import('./views/landing-v3/privacy-policy/index'))
  },
  {
    exact: true,
    path: '/sign-pdf',
    component: lazy(() => import('./views/pages/BillingPdfSign/index'))
  },
  {
    exact: true,
    layout: CampaignGenrationLayout,
    path: '/manual-keyword-targeting-campaign-generation',
    component: lazy(() => import('./views/pages/campaign-bulk/campaign-generation/index'))
  },
  {
    exact: true,
    layout: CampaignGenrationLayout,
    path: '/manual-product-targeting-campaign-generation',
    component: lazy(() => import('./views/pages/campaign-bulk/campaign-generation/index'))
  },
  {
    path: '*',
    layout: AdminLayout,
    guard: AuthGuard,
    routes: [
      {
        exact: true,
        path: '/plan-expired/:provider',
        component: lazy(() => import('./views/upgrade/index'))
      },
      // {
      //   exact: true,
      //   path: '/targeting-summary',
      //   component: () => <Redirect to={process.env.REACT_APP_ACCOUNT_SUMMARY_ENABLE === '1' ? '/summary/account' : '/summary/all-campaigns'} />
      // },
      // {
      //   exact: true,
      //   path: '/targeting-summary-new',
      //   component: lazy(() => import('./views/pages/targettingSummaryNew/index'))
      // },
      // {
      //   exact: true,
      //   path: '/targeting-summary-new',
      //   component: () => <Redirect to={`/summary/all-campaigns`} />
      // },
      {
        exact: true,
        guard: AuthGuard,
        accessGuard: DspAccessGuard,
        path: '/amazon-dsp/:type',
        component: lazy(() => import('./views/pages/Dsp/index'))
      },
      {
        exact: true,
        guard: AuthGuard,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp/:type/create',
        component: lazy(() => import('./views/pages/Dsp/index'))
      },
      {
        exact: true,
        guard: AuthGuard,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp/:type/:id/update',
        component: lazy(() => import('./views/pages/Dsp/index'))
      },
      {
        exact: true,
        guard: AuthGuard,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp/:type/:id/draft',
        component: lazy(() => import('./views/pages/Dsp/index'))
      },
      // {
      //   exact: true,
      //   guard: AuthGuard,
      //   path: '/amazon-dsp/:type/:reportType',
      //   component: lazy(() => import('./views/pages/Dsp/index'))
      // },
      {
        exact: true,
        guard: AuthGuard,
        accessGuard: DspAccessGuard,
        path: '/amazon-dsp-logs',
        component: lazy(() => import('./views/pages/dsp-logs/index'))
      },
      {
        exact: true,
        guard: AuthGuard,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-automated-rules/:type_rule',
        component: lazy(() => import('./views/pages/Dsp/rules'))
      },
      {
        exact: true,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-automated-rules/:type_rule/create',
        component: lazy(() => import('./views/pages/Dsp/rules/pages/main'))
      },
      {
        exact: true,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-automated-rules/:type_rule/view-logs/:type_rule_id',
        component: lazy(() => import('./views/pages/Dsp/rules/pages/rules'))
      },
      {
        exact: true,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-automated-rules/:type_rule/details/:type_rule_id',
        component: lazy(() => import('./views/pages/Dsp/rules/pages/main'))
      },
      {
        exact: true,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-automated-rules/:type_rule/view-logs/:type_rule_id/details/:check_id',
        component: lazy(() => import('./views/pages/Dsp/rules/pages/rules'))
      },
      {
        exact: true,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp/marketing-stream',
        component: lazy(() => import('./views/pages/Dsp/marketing-stream/index'))
      },
      {
        exact: true,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-dayparting-performance',
        component: lazy(() => import('./views/pages/Dsp/dayparting/index'))
      },
      {
        exact: true,
        accessGuard: DspAccessGuard,
        path: '/amazon-dsp-dayparting-scheduler',
        component: lazy(() => import('./views/pages/Dsp/dayparting/dayparting-schedular/index'))
      },
      {
        exact: true,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-dayparting-history',
        component: lazy(() => import('./views/pages/Dsp/dayparting/dayparting-history/index'))
      },
      {
        exact: true,
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-dayparting-schedule-log',
        component: lazy(() => import('./views/pages/Dsp/dayparting/dayparting-history/schedule-log'))
      },
      {
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-dayparting-schedule-log/:slotType',
        exact: true,
        component: lazy(() => import('./views/pages/Dsp/dayparting/dayparting-history/schedule-log'))
      },
      {
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-dayparting-schedule-log/:slotType/:slotId/:slotAction',
        exact: true,
        component: lazy(() => import('./views/pages/Dsp/dayparting/dayparting-history/schedule-log'))
      },
      {
        accessGuard: DspPlatformFeeAccessGuard,
        path: '/amazon-dsp-smart-campaigns',
        exact: true,
        component: lazy(() => import('./views/pages/Dsp/smart-campaigns/campaign-form/main'))
      },
      {
        exact: true,
        guard: AuthGuard,
        path: '/amazon-dsp-request',
        component: lazy(() => import('./views/pages/Dsp/onboarding/RequestPage'))
      },
      {
        exact: true,
        guard: AuthGuard,
        path: '/amazon-dsp-request/create',
        component: lazy(() => import('./views/pages/Dsp/onboarding/RequestPage'))
      },
      {
        exact: true,
        guard: AuthGuard,
        path: '/dsp-only-request/create',
        component: lazy(() => import('./views/pages/Dsp/onboarding/RequestPage'))
      },
      {
        exact: true,
        path: '/summary-old/:report_id',
        component: lazy(() => import('./views/pages/dashboards/index'))
      },
      {
        exact: true,
        path: '/summary-new-1/:report_id',
        component: lazy(() => import('./views/pages/dashboards/index'))
      },
      {
        exact: true,
        path: '/myntra-categorization',
        component: lazy(() => import('./views/pages/re-design/categorization-new/index'))
      },
      {
        exact: true,
        path: '/blinkit-categorization',
        component: lazy(() => import('./views/pages/re-design/categorization-new/index'))
      },
      {
        exact: true,
        path: '/flipkart-categorization',
        component: lazy(() => import('./views/pages/re-design/categorization-new/index'))
      },
      {
        exact: true,
        path: '/instamart-categorization',
        component: lazy(() => import('./views/pages/re-design/categorization-new/index'))
      },
      {
        exact: true,
        path: '/zepto-categorization',
        component: lazy(() => import('./views/pages/re-design/categorization-new/index'))
      },
      {
        exact: true,
        path: '/bigbasket-categorization',
        component: lazy(() => import('./views/pages/re-design/categorization-new/index'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-categorization',
        component: lazy(() => import('./views/pages/re-design/categorization-new/index'))
      },
      {
        exact: true,
        path: '/amazon-dsp-categorization',
        component: lazy(() => import('./views/pages/re-design/categorization-new/index'))
      },
      // {
      //   exact: true,
      //   path: '/categorization-ip',
      //   component: lazy(() => import('./views/pages/categorization-new/index'))
      // },
      {
        exact: true,
        path: '/categorization-old',
        component: lazy(() => import('./views/pages/categorization-new/index'))
      },
      {
        exact: true,
        path: '/heat-map',
        component: lazy(() => import('./views/pages/heatMap/index'))
      },
      {
        exact: true,
        path: '/keyword-harvesting',
        component: lazy(() => import('./views/pages/keywordHarvesting/index'))
      },
      {
        exact: true,
        path: '/brand-view-sqp-report',
        component: lazy(() => import('./views/pages/BrandView/index'))
      },
      {
        exact: true,
        path: '/asin-view-sqp-report',
        component: lazy(() => import('./views/pages/AsinView/index'))
      },
      {
        exact: true,
        path: '/scp-view-sqp-report',
        component: lazy(() => import('./views/pages/SCPView/index'))
      },
      {
        exact: true,
        path: '/text-categorization-old',
        component: lazy(() => import('./views/pages/re-design/brand-categorization/index'))
      },
      {
        exact: true,
        path: '/search-term',
        component: lazy(() => import('./views/pages/search-term/SearchTerm'))
      },
      {
        exact: true,
        path: '/seller-sales',
        component: lazy(() => import('./views/pages/sellerSales/index'))
      },
      // {
      //   exact: true,
      //   path: '/snapshot',
      //   component: lazy(() => import('./views/pages/snapshot/index'))
      // },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-snapshot',
        component: lazy(() => import('./views/pages/snapshot_new/index'))
      },
      {
        exact: true,
        path: '/amazon-snapshot/welcome',
        component: lazy(() => import('./views/pages/snapshot_new/index'))
      },
      {
        exact: true,
        path: '/flipkart-snapshot',
        component: lazy(() => import('./views/pages/snapshot_new/fk-snapshot'))
      },
      {
        exact: true,
        path: '/seller-sales-new',
        component: lazy(() => import('./views/pages/seller-sales-new'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-master-overview',
        component: lazy(() => import('./views/pages/master-overview/index'))
      },
      {
        exact: true,
        path: '/flipkart-master-overview',
        component: lazy(() => import('./views/pages/master-overview/fk-master-overview'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-dayparting-performance',
        exact: true,
        component: lazy(() => import('./views/pages/dayparting/index'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-dayparting-tracking',
        exact: true,
        component: lazy(() => import('./views/pages/dayparting/dayparting-tracking/index'))
      },
      {
        path: '/master-dayparting-tracking',
        exact: true,
        component: lazy(() => import('./views/pages/dayparting/master-dayparting-tracking/index'))
      },
      {
        path: '/master-error-tracking/:type',
        exact: true,
        component: lazy(() => import('./views/pages/dayparting/master-error-tracking/index'))
      },
      {
        path: '/master-error-tracking/:type/rule-based',
        exact: true,
        component: lazy(() => import('./views/pages/dayparting/master-error-tracking/rule-based/index'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-bid-scheduler',
        exact: true,
        component: lazy(() => import('./views/pages/bid-scheduler/index'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-dayparting-scheduler',
        exact: true,
        component: lazy(() => import('./views/pages/dayparting/dayparting-schedular/index'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-dayparting-history',
        exact: true,
        component: lazy(() => import('./views/pages/dayparting/dayparting-history/index'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-dayparting-schedule-log',
        exact: true,
        component: lazy(() => import('./views/pages/dayparting/dayparting-history/schedule-log'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-dayparting-schedule-log/:slotType',
        exact: true,
        component: lazy(() => import('./views/pages/dayparting/dayparting-history/schedule-log'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-dayparting-schedule-log/:slotType/:slotId/:slotAction',
        exact: true,
        component: lazy(() => import('./views/pages/dayparting/dayparting-history/schedule-log'))
      },
      {
        path: '/amazon-dsp-dayparting-schedule-log/:slotType/:slotId/:slotAction',
        exact: true,
        component: lazy(() => import('./views/pages/Dsp/dayparting/dayparting-history/schedule-log'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        path: '/dayparting-scheduler',
        exact: true,
        component: lazy(() => import('./views/pages/bid-scheduler/Dayparting-schedular/index'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        exact: true,
        path: '/amazon-user-management',
        component: lazy(() => import('./views/pages/user-management/index'))
      },
      {
        exact: true,
        accessGuard: DspAccessGuard,
        path: '/amazon-dsp-user-management',
        component: lazy(() => import('./views/pages/user-management/index'))
      },
      {
        exact: true,
        path: '/flipkart-user-management',
        component: lazy(() => import('./views/pages/user-management/index'))
      },
      {
        exact: true,
        path: '/instamart-user-management',
        component: lazy(() => import('./views/pages/user-management/index'))
      },
      {
        exact: true,
        path: '/myntra-user-management',
        component: lazy(() => import('./views/pages/user-management/index'))
      },
      {
        exact: true,
        path: '/blinkit-user-management',
        component: lazy(() => import('./views/pages/user-management/index'))
      },
      {
        exact: true,
        path: '/zepto-user-management',
        component: lazy(() => import('./views/pages/user-management/index'))
      },
      {
        exact: true,
        path: '/bigbasket-user-management',
        component: lazy(() => import('./views/pages/user-management/index'))
      },
      {
        exact: true,
        path: '/thankyou',
        component: lazy(() => import('./views/pages/thankyou/index'))
      },
      {
        exact: true,
        path: '/thankyou/:instanceType',
        component: lazy(() => import('./views/pages/thankyou/index'))
      },
      {
        exact: true,
        path: '/profile-old',
        component: lazy(() => import('./views/pages/profile/Profile'))
      },
      {
        exact: true,
        path: '/profile',
        component: lazy(() => import('./views/pages/profile-new/AccountManager/index'))
      },
      {
        exact: true,
        path: '/connect-mcp',
        component: lazy(() => import('./views/pages/connect-mcp/index'))
      },

      // {
      //   exact: true,
      //   path: '/add-profile',
      //   component: lazy(() => import('./views/pages/profile/AddAccount/SaveProfile'))
      // },
      {
        exact: true,
        path: '/users',
        component: lazy(() => import('./views/pages/users/Users'))
      },
      {
        exact: true,
        guard: AuthGuard,
        accessGuard: SubscriptionGuard,
        path: '/addaccount',
        // component: lazy(() => import('./views/pages/profile/AddAccount/AddAccount'))
        component: lazy(() => import('./views/pages/profile-new/AddAccount/index'))
      },
      {
        exact: true,
        path: '/aws/callback',
        component: lazy(() => import('src/components/Loader/FallbackLoader'))
      },
      {
        exact: true,
        path: '/edituser',
        component: lazy(() => import('./views/pages/users/edituser/edituser'))
      },
      {
        exact: true,
        path: '/charts',
        component: lazy(() => import('./views/pages/dashboards/static-index'))
      },
      {
        exact: true,
        path: '/api-testing',
        component: lazy(() => import('./testing/index'))
      },
      {
        exact: true,
        path: '/user-activity/dashboard',
        component: lazy(() => import('./views/pages/admin-dashboard/index'))
      },
      {
        exact: true,
        path: '/user-activity/retention-dashboard',
        component: lazy(() => import('./views/pages/retention-dashboard/index'))
      },
      {
        exact: true,
        path: '/flipkart-dashboard-old',
        component: lazy(() => import('./views/pages/dashboards/flipkart-dashboard'))
      },
      {
        exact: true,
        path: '/flipkart-dashboard',
        component: () => <Redirect to="/summary/flipkart" />
      },
      {
        path: '/user-activity/timespend',
        component: lazy(() => import('./views/pages/TimeSpendBy/timespend'))
      },
      {
        exact: true,
        path: '/user-activity/time-spend-dashboard',
        component: lazy(() => import('./views/pages/TimeSpendBy/index'))
      },
      {
        exact: true,
        path: '/user-activity/clients',
        component: lazy(() => import('./views/pages/ClientList/index'))
      },
      {
        exact: true,
        path: '/billing',
        component: lazy(() => import('./views/pages/billing/index'))
      },
      {
        exact: true,
        path: '/amazon-hector-sov',
        component: lazy(() => import('./views/pages/sov/index'))
      },
      {
        exact: true,
        path: '/account-settings',
        component: lazy(() => import('./views/pages/accountSettings/billing-details/index'))
      },
      {
        exact: true,
        path: '/edit-profile/:popupType?',
        component: lazy(() => import('./views/pages/profiles/index'))
      },
      {
        exact: true,
        path: '/account-settings/:is_upgrade/:for_upgrade',
        component: lazy(() => import('./views/pages/accountSettings/index'))
      },
      {
        exact: true,
        path: '/plan-selection/payment',
        component: lazy(() => import('./views/pages/accountSettings/plan-payment/index'))
      },
      {
        exact: true,
        path: '/account-settings/upgrade',
        component: lazy(() => import('./views/pages/accountSettings/plan-payment/index'))
      },
      {
        exact: true,
        path: '/plan-selection/payment/status',
        component: lazy(() => import('./views/pages/accountSettings/plan-payment/components/PaymentStatus'))
      },
      {
        exact: true,
        path: '/payment/:status',
        component: lazy(() => import('./views/pages/accountSettings/status'))
      },
      {
        exact: true,
        path: '/targeting-360',
        component: lazy(() => import('./views/pages/targetting/index'))
      },
      {
        exact: true,
        path: '/myntra-text-categorization',
        component: lazy(() => import('src/views/pages/text-categorization/index'))
      },
      {
        exact: true,
        path: '/blinkit/text-categorization',
        component: lazy(() => import('src/views/pages/text-categorization/index'))
      },
      {
        exact: true,
        path: '/zepto-text-categorization',
        component: lazy(() => import('src/views/pages/text-categorization/index'))
      },
      {
        exact: true,
        path: '/bigbasket-text-categorization',
        component: lazy(() => import('src/views/pages/text-categorization/index'))
      },
      {
        exact: true,
        path: '/summary/:report_id',
        // component: lazy(() => import('./views/pages/dashboards/index'))
        component: lazy(() => import('./views/pages/targetting/report-dashboard'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        exact: true,
        path: '/amazon/marketing-stream',
        component: lazy(() => import('./views/pages/targetting/report-dashboard'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon/targeting',
        component: lazy(() => import('./views/pages/targetting/report-dashboard'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        exact: true,
        path: '/amazon/search-query-performance',
        component: lazy(() => import('./views/pages/targetting/report-dashboard'))
      },
      {
        exact: true,
        path: '/amazon/targeting/:customAsin/:customType',
        component: lazy(() => import('./views/pages/targetting/report-dashboard'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        exact: true,
        path: '/amazon/campaign-drafts',
        component: lazy(() => import('./views/pages/campaign-bulk/campaign-list/index'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        exact: true,
        path: '/amazon/smart-campaigns/list',
        component: lazy(() => import('./views/pages/campaign-bulk/campaign-list/smart-campaigns'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        exact: true,
        path: '/amazon/smart-campaigns/drafts',
        component: lazy(() => import('./views/pages/campaign-bulk/campaign-list/smart-campaigns'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        exact: true,
        path: '/amazon/smart-campaigns',
        component: lazy(() => import('./views/pages/campaign-bulk/campaign-list/smart-campaigns'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        exact: true,
        path: '/amazon/campaign-drafts/:campaignType/create/:sessionId?',
        component: lazy(() => import('./views/pages/campaign-bulk/campaign-generation/index'))
      },
      {
        accessGuard: SpAdsAccessGuard,
        exact: true,
        path: '/amazon-dummy',
        component: lazy(() => import('./views/pages/targetting/index'))
      },
      {
        exact: true,
        path: '/flipkart-text-categorization',
        component: lazy(() => import('src/views/pages/text-categorization/index'))
      },
      {
        exact: true,
        path: '/flipkart/cpc-job-listing/:jobId?',
        component: lazy(() => import('./views/pages/cpc-job-listing/index'))
      },
      {
        exact: true,
        path: '/instamart-text-categorization',
        component: lazy(() => import('src/views/pages/text-categorization/index'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-text-categorization',
        component: lazy(() => import('src/views/pages/text-categorization/index'))
      },
      {
        exact: true,
        accessGuard: DspAccessGuard,
        path: '/amazon-dsp-text-categorization',
        component: lazy(() => import('src/views/pages/amazon-dsp-text-categorization/index'))
      },
      {
        exact: true,
        path: '/amazon/sqp-text-categorization',
        component: lazy(() => import('src/views/pages/text-categorization/index'))
      },
      {
        exact: true,
        path: '/summary/:report_id/:keywordId/:keywordText',
        // component: lazy(() => import('./views/pages/dashboards/index'))
        component: lazy(() => import('./views/pages/targetting/report-dashboard'))
      },
      {
        exact: true,
        path: '/account-management',
        component: lazy(() => import('./views/pages/profile-new/AccountManagement/index'))
      },
      {
        exact: true,
        path: '/add-profile',
        component: lazy(() => import('./views/pages/profile-new/SelectProfile/index'))
      },
      {
        exact: true,
        path: '/account-manager',
        component: lazy(() => import('./views/pages/profile-new/AccountManager/index'))
      },
      {
        exact: true,
        path: '/rules',
        component: lazy(() => import('./views/pages/rules/index'))
      },
      {
        exact: true,
        path: '/rules-new',
        component: lazy(() => import('./views/pages/rules-new/index'))
      },
      {
        exact: true,
        path: '/blacklist',
        component: lazy(() => import('./views/pages/Blacklist/index'))
      },
      {
        exact: true,
        path: '/custom/payments',
        component: lazy(() => import('./views/pages/Custom-Payments/index'))
      },
      {
        exact: true,
        guard: DspGuard,
        path: '/billing-payments',
        component: lazy(() => import('./views/pages/Billing-Payments/index'))
      },
      {
        exact: true,
        path: '/cpc/history',
        component: lazy(() => import('./views/pages/History/index'))
      },
      {
        exact: true,
        path: '/admin/client-access-details',
        component: lazy(() => import('./views/super-admin/client-access-details'))
      },
      {
        exact: true,
        path: '/admin/hector-registrations',
        component: lazy(() => import('./views/pages/hector-registration/index'))
      },
      {
        exact: true,
        path: '/admin/manual-transaction-details',
        component: lazy(() => import('./views/super-admin/manual-transaction-details/manual-transaction-details'))
      },
      // {
      //   exact: true,
      //   path: '/admin/coupons',
      //   component: lazy(() => import('./views/pages/coupons/index'))
      // },
      {
        exact: true,
        path: '/admin/coupons',
        component: lazy(() => import('./views/pages/Custom-Coupons/index'))
      },
      {
        exact: true,
        path: '/admin/useraccountdetails',
        component: lazy(() => import('./views/pages/user-account-details/index'))
      },
      {
        exact: true,
        AccessGurd: AmcAccessGuard,
        path: '/amazon-audience-report',
        component: lazy(() => import('./views/pages/audience-report/index'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-asin-audience-report',
        component: lazy(() => import('./views/pages/asin-audience-report/index'))
      },
      {
        exact: true,
        path: '/settings/amazon',
        component: lazy(() => import('./views/pages/settings/index'))
      },
      {
        exact: true,
        path: '/amazon-blacklist-keywords',
        component: lazy(() => import('./views/super-admin/blacklist-rule/index'))
      },
      {
        exact: true,
        path: '/amazon-chatgpt',
        component: lazy(() => import('./views/pages/chatgpt/index'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-create-audience',
        component: lazy(() => import('./views/pages/audience-report/create-audience'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-view-audience/:audienceid',
        component: lazy(() => import('./views/pages/audience-report/create-audience'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-insights',
        component: lazy(() => import('./views/pages/amc-insights/amc-insight-template'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-path-to-conversion',
        component: lazy(() => import('./views/pages/amc-insights/amc-path-conversion'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-custom-attribution',
        component: lazy(() => import('./views/pages/amc-insights/amc-custom-attribution-v2'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-time-to-conversion',
        component: lazy(() => import('./views/pages/amc-insights/amc-time-to-converstion'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-budget-rules-creation',
        component: lazy(() => import('./views/pages/rules-navigation/pages/index.js'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-automated-rules/:type_rule',
        component: lazy(() => import('./views/pages/rules-navigation/pages/rules'))
      },
      {
        exact: true,
        path: '/flipkart-automated-rules/:type_rule',
        component: lazy(() => import('./views/pages/rules-navigation/pages/rules'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-automated-rules/:type_rule/view-logs/:type_rule_id',
        component: lazy(() => import('./views/pages/rules-navigation/pages/rules'))
      },
      {
        exact: true,
        path: '/flipkart-automated-rules/:type_rule/view-logs/:type_rule_id',
        component: lazy(() => import('./views/pages/rules-navigation/pages/rules'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-automated-rules/:type_rule/view-logs/:type_rule_id/details/:check_id',
        component: lazy(() => import('./views/pages/rules-navigation/pages/rules'))
      },
      {
        exact: true,
        path: '/flipkart-automated-rules/:type_rule/view-logs/:type_rule_id/details/:check_id',
        component: lazy(() => import('./views/pages/rules-navigation/pages/rules'))
      },
      {
        exact: true,
        path: '/rule-based-simulate',
        component: lazy(() => import('./views/pages/rule-based-simulate/index'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-automated-rules/:type_rule/view-logs-notifications/:type_rule_id/details/:check_id',
        component: lazy(() => import('./views/pages/rules-navigation/pages/rules'))
      },
      {
        exact: true,
        path: '/amazon-dsp-automated-rules/:type_rule/view-logs-notifications/:type_rule_id/details/:check_id',
        component: lazy(() => import('./views/pages/Dsp/rules/pages/rules'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-automated-rules/:type_rule/create',
        component: lazy(() => import('./views/pages/rules-navigation/pages/main'))
      },
      {
        exact: true,
        path: '/flipkart-automated-rules/:type_rule/create',
        component: lazy(() => import('./views/pages/rules-navigation/pages/main'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-automated-rules/:type_rule/create/:template_id',
        component: lazy(() => import('./views/pages/rules-navigation/pages/main'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-automated-rules/:type_rule/templates',
        component: lazy(() => import('./views/pages/rules-navigation/pages/templates/main'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-automated-rules/:type_rule/details/:type_rule_id',
        component: lazy(() => import('./views/pages/rules-navigation/pages/main'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-automated-rules/:type_rule/details/:type_rule_id/clone',
        component: lazy(() => import('./views/pages/rules-navigation/pages/main'))
      },
      {
        exact: true,
        path: '/flipkart-automated-rules/:type_rule/details/:type_rule_id',
        component: lazy(() => import('./views/pages/rules-navigation/pages/main'))
      },
      {
        exact: true,
        path: '/flipkart-automated-rules/:type_rule/details/:type_rule_id/clone',
        component: lazy(() => import('./views/pages/rules-navigation/pages/main'))
      },
      {
        exact: true,
        accessGuard: SpAdsAccessGuard,
        path: '/amazon-history',
        component: lazy(() => import('./views/pages/ad-account-history/index'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-audience-instance',
        component: lazy(() => import('./views/pages/amc-instance/index'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-audience-instance/create',
        component: lazy(() => import('./views/pages/amc-instance/onboarding'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-audience-instance-register/create',
        component: lazy(() => import('./views/pages/amc-instance/onboarding'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-audience-instance-info/:instance_id',
        component: lazy(() => import('./views/pages/amc-instance/audience-instance-info'))
      },
      {
        exact: true,
        accessGuard: DspAccessGuard,
        path: '/dsp-credit-top-up',
        component: lazy(() => import('./views/pages/dsp-payment/payment-page/index'))
      },
      {
        exact: true,
        accessGuard: DspAccessGuard,
        path: '/dsp-wallet',
        component: lazy(() => import('./views/pages/dsp-payment/wallet-page/index'))
      },
      {
        exact: true,
        accessGuard: DspAccessGuard,
        path: '/dsp-payment',
        component: lazy(() => import('./views/pages/dsp-payment/payment-page/index'))
      },
      {
        exact: true,
        accessGuard: DspAccessGuard,
        path: '/dsp-invoice-history',
        component: lazy(() => import('./views/pages/dsp-payment/invoice-history/index'))
      },
      {
        exact: true,
        accessGuard: DspAccessGuard,
        path: '/dsp-payment-confirmation',
        component: lazy(() => import('./views/pages/dsp-payment/confirmation-page/index'))
      },
      {
        exact: true,
        path: '/session-logs',
        component: lazy(() => import('./views/pages/session-logs/index'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-tentpole-report',
        component: lazy(() => import('./views/pages/amc-insights/amc-tentpole-report'))
      },
      {
        exact: true,
        path: '/app-user-tracking',
        component: lazy(() => import('./views/pages/admin/app-user-tracking/index'))
      },
      {
        exact: true,
        path: '/admin/salesbricks-plan-mapping',
        component: lazy(() => import('./views/pages/admin/salesbricks-plan-mapping/index'))
      },
      {
        exact: true,
        path: '/brands-dashboard',
        component: lazy(() => import('./views/pages/admin/agency-dashboard/index'))
      },
      {
        exact: true,
        path: '/app-usage-settings',
        component: lazy(() => import('./views/pages/app-user-tracking-settings/index'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-first-party-data',
        component: lazy(() => import('./views/pages/amc-first-party-data/index'))
      },
      {
        exact: true,
        accessGuard: AmcAccessGuard,
        path: '/amazon-first-party-demo-data/:table_id',
        component: lazy(() => import('./views/pages/amc-first-party-data/components/details-page'))
      },
      {
        exact: false,
        path: '/sponsored-ads/dashboard',
        component: lazy(() => import('./views/pages/sponsored-ads-dashboard/index'))
      },
      {
        path: "/genai/openchat/campaign",
        exact: false,
        component: () => {
          // Don't render anything, let Apache proxy to Next.js
          window.location.href = "/genai/openchat/campaign";
          return null;
        }
      },
      {
        exact: true,
        path: '/amazon/inialize',
        component: lazy(() => import('./views/amazon-initialize/index'))
      },
      {
        exact: true,
        path: '/amazon/cpc-job-listing/:jobId?',
        component: lazy(() => import('./views/pages/cpc-job-listing/index'))
      },
      {
        exact: true,
        path: '/amazon-ranking-configuration',
        component: lazy(() => import('./views/pages/ranking-dashboard/index'))
      },
      {
        exact: true,
        path: '/amazon-ranking-activity',
        component: lazy(() => import('./views/pages/ranking-dashboard/activity-list/index'))
      },
      {
        exact: true,
        path: '/amazon-ranking-dashboard',
        component: lazy(() => import('./views/pages/ranking-dashboard/analysis/index'))
      },
      {
        exact: true,
        path: '/amazon-ranking-billing-payments',
        component: lazy(() => import('./views/pages/ranking-dashboard/ranking-billing-payments/index'))
      },
      {
        path: '*',
        exact: true,
        component: () => {
          const ParseData = JSON.parse(localStorage.getItem('User'));
          const journeyDetails = ParseData?.journeyDetails || {};

          if (ParseData?.planDetails?.only_mcp === true) return <Redirect to="/profile" />;
          const redirect = useRedirectJourney(journeyDetails);
          if (redirect) return redirect;

          return <Redirect to={BASE_URL} />;
        }
      }
    ]
  }
];

export default routes;
